import React from 'react';
import './historic_data_unavailable.component.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const HistoricDataUnavailable = (props) => {
  return (
    <section className={`mt-2 w-100 position-relative`}>
      {props.section === 'perf_index' && (
        <span className="content-info-text">
          Your portfolio index tracks the market value of the investments you
          made. Your benchmark indices track their market value if you had
          bought/sold them instead.
        </span>
      )}
      <div className={`historic-data-banner ${props.className ?? ''}`}>
        <FontAwesomeIcon icon={faExclamationCircle} />
        <div>
          <h6 className="title">Feature Unavailable in Broker Sync Mode</h6>
          {props.isFamily ? (
            <p className="info">
              One or more of your portfolios are connected using Broker Sync.
              And we do not have access to historical portfolio information
            </p>
          ) : (
            <p className="info">
              We do not have access to historic portfolio information, as your
              portfolio is currently connected using broker sync
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default HistoricDataUnavailable;
